module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"growth":"Growth"},"cs":{"growth":"Růst"}}')
  delete Component.options._Ctor
}
